// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import * as CryptoJS from 'crypto-js';

let setEncry = async (keys, value) => {
  let key = CryptoJS.enc.Utf8.parse(keys);
  let iv = CryptoJS.enc.Utf8.parse(keys);
  let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
    {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

  return encrypted.toString();
}

export const environment = {
  production: false,
  apiUrl: 'http://localhost:3001/api',
  phpApiUrl: 'https://localhost/blog/api_v1/webservices/index.php?apicall',
  baseUrl : 'http://localhost:3001/',
  webURL : 'https://localhost:4201/',
  websiteURL : 'https://localhost:4201',
  mciURL : 'http://mci.staging.mindpeers.co?aid=',

  razorPayKey: setEncry('123456$#@$^@1ERF','rzp_test_QwUe00UT8eavJ9'),
  HOST: 'https://securegw-stage.paytm.in',
  MID: 'ygXgLD97497673846824',
  CALLBACK_URL : 'http://localhost:3000/paytmCallback',
  FBAPPID: '2426196550790693',
  FBPIXELID: '274081876830049',
  imgKey: 'mp986547@#%!$w',
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
